import { Skeleton } from '@machobear/design-system'

import HasPaymentMethod from './has-payment-method'
import PaymentForm from './payment-form'

type Props = {
  showSkeleton: boolean
  setState: any
  hasPaymentMethods: boolean
  paymentMethod: any
  showExpiryDateWarning: boolean
}

const PaymentMethodStep = ({
  showSkeleton,
  setState,
  hasPaymentMethods,
  paymentMethod,
  showExpiryDateWarning
}: Props) => {
  if (showSkeleton) return <Skeleton.Shape width="100%" height={96} />
  return hasPaymentMethods ? (
    <HasPaymentMethod
      showSkeleton={showSkeleton}
      paymentMethod={paymentMethod}
      showExpiryDateWarning={showExpiryDateWarning}
      setState={setState}
    />
  ) : (
    <PaymentForm setState={setState} />
  )
}

export default PaymentMethodStep
